import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { Http, HttpModule, RequestOptions } from '@angular/http';
import { FormsModule } from '@angular/forms';

import { AppComponent } from './components/app/app.component';
import { NavMenuComponent } from './components/navmenu/navmenu.component';
import { AuthConfig, AuthHttp } from 'angular2-jwt';
import { authHttpServiceFactory } from './auth.module';
import { SettingsAuthComponent } from './components/settings-auth/settings-auth.component';
import { SettingsComponent } from './components/settings/settings.component';
import { SettingsAttributesComponent } from './components/settings-attributes/settings-attributes.component';
import { NotifyComponent } from './components/notify/notify.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { SettingsClientComponent } from './components/settings-client/settings-client.component';
import { ProductsComponent } from './components/products/products.component';

import {
  AuthGuard,
  AuthService,
  ConfigService,
  HttpClientService,
  LoggingService,
  NotifyService,
  ScopeService } from './services/services';

import { ProductsSidebarComponent } from './components/products-sidebar/products-sidebar.component';

import { SharedModule } from './shared/shared.module';
import { ScopesComponent } from './components/scopes/scopes.component';

export function loadConfig(configService: ConfigService) {
  return () => configService.loadConfig();
}

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    SettingsAuthComponent,
    SettingsComponent,
    SettingsAttributesComponent,
    NotifyComponent,
    SpinnerComponent,
    SettingsClientComponent,
    ProductsComponent,
    ProductsSidebarComponent,
    ScopesComponent,
  ],
  imports: [
    BrowserModule,
    HttpModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    RouterModule.forRoot([
      { path: '', redirectTo: 'products', pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'products', component: ProductsComponent, canActivate: [AuthGuard] },
      { path: 'scopes', component: ScopesComponent, canActivate: [AuthGuard] },
      { path: 'settings', component: SettingsAuthComponent, canActivate: [AuthGuard] },
  ]),
  ],
  providers: [
    AuthGuard,
        {
            provide: AuthHttp,
            useFactory: authHttpServiceFactory,
            deps: [Http, RequestOptions]
        },
        AuthService,
    ConfigService, {
      provide: APP_INITIALIZER,
      useFactory: loadConfig,
      deps: [ConfigService],
      multi: true
  },
  HttpModule,
  HttpClientService,
  LoggingService,
  NotifyService,
  ScopeService
],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/a/1/s/src/app/app.module.ts